export const getIdVimeo = url => {
  var firstPart = url.split('?')[0].split('/');
  var vid = firstPart[firstPart.length - 1];

  return vid;
};
